// Client questions domain — Q&A between clients and RMAs, template library.
import { API } from './_client';

export const questions = {
  list: (opts = {}) => API.get('/questions', { params: opts }).then((r) => r.data),
  reply: (qid, reply, status = 'answered') =>
    API.post(`/questions/${qid}/reply`, { reply, status }).then((r) => r.data),
  setStatus: (qid, status) => API.post(`/questions/${qid}/status`, { status }).then((r) => r.data),
  rmas: () => API.get('/questions/rmas').then((r) => r.data),
  assign: (qid, user_id) => API.post(`/questions/${qid}/assign`, { user_id }).then((r) => r.data),
  suggestTemplate: (qid) => API.post(`/questions/${qid}/suggest-template`).then((r) => r.data),
  bulkReply: (matter_id, reply, opts = {}) =>
    API.post('/questions/bulk-reply', { matter_id, reply, ...opts }).then((r) => r.data),
  templates: {
    list: () => API.get('/questions/templates').then((r) => r.data),
    create: (label, body) => API.post('/questions/templates', { label, body }).then((r) => r.data),
    remove: (tid) => API.delete(`/questions/templates/${tid}`).then((r) => r.data),
    markUsed: (tid) => API.post(`/questions/templates/${tid}/used`).then((r) => r.data),
  },
};
